/**
 * @file
 * @author  fangsimin
 * @date    2020-02-09 21:29:35
 * @last Modified by    fangsimin
 * @last Modified time  2020-02-09 21:33:48
 */
export default {
    'menuData': {
        'effectMgr': '效果管理',
        'batchMgr': '批量操作',
        'businessMgr': '业务管理',
        'creativeMgr': '素材管理',
        'contentReview': '内容审核',
        'allReview': '综合审核',
        'userReport': '用户举报',
        'simpleRule': '简单规则',
        'dashboard': '业务总览',
        'accountMgr': '开户管理',
        'create-account': '新增账户',
        'ecommerce': 'Web端电商',
        'account': '账户管理',
        'dataReport': '数据详情',
        'authorMgr': '权限管理',
        'role-settings': '角色分配',
        'menu-settings': '功能划分',
        'uri-list': 'URI列表',
        'members': '用户列表',
        'finance': '财务管理',
        'finance-estimate': '财务计收',
        'recharge': '账户充值',
        'recharge-log': '充值记录',
        'account-analysis': '帐户分析',
        'help-center': '帮助中心',
        'creative': '素材列表',
        'customer-relationship': '客户管理',
        'agency': '代理管理',
        'team': '人员管理',
        'creative-rejection': '素材监控',
        'creative-external': '素材结算',
        'operation-log': '操作日志',
        'hour-data': '分小时数据',
        'help-center-doc': '帮助中心文档',
        'help-center-edit': '帮助中心编辑',
        'creative-upload': '上传素材',
        'ads-upload': '创建广告'
    },
    breadcrumb: {
        dashboard: '业务总览',
        report: 'Web端电商',
        overview: '数据详情',
        account: '账户管理',
        'permission-settings': '权限管理',
        members: '用户列表',
        'role-settings': '角色分配',
        'uri-list': 'URI列表',
        'menu-settings': '功能划分',
        'finance': '财务管理',
        'finance-estimate': '财务计收',
        'recharge': '账户充值',
        'recharge-log': '充值记录',
        'account-analysis': '帐户分析',
        'help-center': '帮助中心',
        'creative': '素材列表',
        'customer-relationship': '客户管理',
        'agency': '代理管理',
        'team': '人员管理',
        'creative-rejection': '素材监控',
        'creative-external': '素材结算',
        'operation-log': '操作日志',
        'hour-data': '分小时数据',
        'doc': '帮助中心文档',
        'edit': '帮助中心编辑',
        'bulk-tools': '批量操作',
        'creative-upload': '上传素材',
        'ads-upload': '创建广告',
        'ads': '创建广告'
    },
    columnSetting: {
        columnSetting: '设置列',
        allSelect: '全选',
        columnName: '请选择列名',
        selected: '已选',
        dragTip: '拖放以重新排序',
        clearAllSelect: '清除所有',
        accountInfo: '账户信息',
        productInfo: '产品信息',
        cooperationInfo: '合作信息',
        KpiInfo: 'KPI类型',
        applyInfo: '申请信息',
        commonInfo: '通用信息',
        level: '量级',
        cost: '成本',
        ratio: '比率',
        details: '细节',
        setting: '设置',
        performance: '表现',
        install: '安装',
        conversion: '转化',
        video: '视频',
        'web_url': '落地链接',
        'attribute': '属性',
        'campaign': '广告系列',
        'adgroup': '广告组',
        ad: '广告',
        reportSetting: '设置',
        userInfo: '用户信息',
        creativeDimension: '素材维度',
        productDimension: '产品维度',
        deliveryDimension: '投放维度',
        status: '状态',
        conversions: '转化',
        cost_per_conversion: '转化成本',
        conversion_rate: '转化率',
        skan_conversion: '转化量',
        skan_cost_per_conversion: '转化成本 (SKAN)',
        skan_conversion_rate: '转化率 (SKAN)',
        conversion_purchases_sk_ad_network_total: '购买（SKAN）',
        conversion_add_cart_sk_ad_network_total: '加入购物车（SKAN）',
        cost_per_SK_Ad_Network_ADDs_to_Cart: '加入购入车成本（SKAN）',
        conversion_app_opens_sk_ad_network_total: '应用打开（SKAN）',
        cost_per_SK_Ad_Network_App_Opens: '应用打开单次成本（SKAN）',
        conversion_sign_ups_sk_ad_network_total: '注册（SKAN）',
        cost_per_SK_Ad_Network_Sign_Ups: '注册单次成本（SKAN）',
        conversion_purchases_sk_ad_network_value_total: '购买价值（SKAN）',
        ROAS: 'ROAS（SKAN）',
        CVR: ' CVR（SKAN）',
        withhelds_Rate: 'Withhelds Rate',
        assisted_Rate: 'Assisted Rate',
        cost_per_SK_Ad_Network_Purchases: '单次购买成本（SKAN）'
    },
    filterings: {
        performance: '表现',
        install: '安装',
        quota: '指标'
    },
    dashboard: {
        baseDate: '基准日期',
        avalibaleBalance: '可用余额',
        yestaerday: '昨天',
        dayBeforeYesterday: '前天',
        lastSevenDay: '近7天',
        currentMonth: '本月累计',
        compareLastTime: '同比上周',
        compareLastSevenDay: '环比前7天',
        ninetyDaysSummary: '90天累计',
        date: '日期',
        lastWeek: '上期流水',
        thisWeek: '本期流水',
        project: '业务线',
        turnover: '实际流水',
        income: '实际收入',
        monthTurnover: '预估本月流水',
        monthIncome: '预估本月收入',
        quarterTurnover: '预估本季度流水',
        quarterIncom: '预估本季度收入',
        total: '汇总',
        costRank: '花费排行榜',
        costUpRank: '花费上涨排行榜',
        costDownRank: '花费下降排行榜',
        budgetUpRank: '预算上涨排行榜',
        budgetDownRank: '预算下降排行榜'
    },
    ecommerce: {
        spend: '花费',
        impressions: '展示数',
        ctr: '点击率',
        'swipe_up_percent': '点击率',
        budget: '预算',
        'purchase_cost': '单次购买成本',
        'install_rate': '安装率',
        click: '点击数',
        purchase: '购买数',
        cpm: '千次展示成本',
        cpc: '单次点击成本',
        'cost_per_purchase': '单次购买成本',
        roas: 'ROAS'
    },
    accountChart: {
        baseDate: '基准日期',
        avalibaleBalance: '可用余额',
        yestaerday: '昨天花费',
        dayBeforeYesterday: '前天花费',
        lastSevenDay: '近7天花费',
        currentMonth: '本月累计花费',
        compareLastTime: '同比上周',
        compareLastSevenDay: '环比前7天',
        monthSummary: '30天累计',
        account: '账户',
        application: '产品',
        type: '类型',
        top10: '前十',
        costUp: '消耗上涨',
        costDown: '消耗下降',
        budgetUp: '预算上涨',
        budgetDown: '预算下降',
        accountName: '账户名称',
        appName: '应用名称',
        yestaerdayCost: '昨日',
        todayCost: '今日',
        compareChange: '同比变化',
        compareChangeRate: '同比变化率',
        heavyGame: '重度游戏',
        lightGame: '休闲游戏',
        tool: '工具',
        ecommerce: '电商',
        social: '社交',
        other: '其他',
        cost: '花费',
        budget: '预算',
        lastWeek: '上周花费',
        thisWeek: '本周花费'
    },
    formValidation: {
        userNameRequired: '请输入账户',
        pwdRequired: '请输入密码',
        email: '请输入合法的邮箱',
        emailRequired: '请输入邮箱',
        number: '请输入合法的电话号码',
        userName: '请输入用户名',
        companyName: '请输入公司名',
        name: '请输入姓名',
        jobTitle: '请输入职位'
    },
    permission: {
        title: '完善资料',
        userName: '用户名',
        companyName: '公司',
        name: '姓名',
        jobTitle: '职位',
        formEmail: '邮箱',
        phone: '电话',
        apply: '保存'
    },
    dataReport: {
        dateLevel: '时间层级',
        accountLevel: '账户层级',
        campaignLevel: '广告系列',
        adGroupLevel: '广告组',
        ad: '广告'
    },
    label: {
        date: '分日',
        week: '分周',
        month: '分月',
        'media_name': '媒体',
        'account_name': '账户',
        'account_id': '媒体账户ID',
        proxy: '代理',
        'company_name': '公司',
        'product_name': '产品',
        'product_type': '产品类型',
        'sub_product_type': '子产品类型',
        'customer_subject': '签约主体',
        'customer': '客户',
        'custom_type': '客户类型',
        'bd_user_name': 'BD',
        'bd': 'BD',
        'am': 'AM',
        'am_user_name': 'AM',
        objective: '广告目标',
        status: '状态',
        'campaign_id': '广告系列ID',
        'start_time': '开启时间',
        'update_time': '更新时间',
        'end_time': '结束时间',
        'campaign_name': '广告系列名称',
        spend: '花费',
        impression: '展示',
        cpm: '千次展示费用',
        click: '点击',
        ctr: '点击率',
        cpc: '单次点击费用',
        install: '安装',
        'install_rate': '安装率',
        cpi: '单次安装费用',
        'page_view': '落地页浏览量',
        'view_content': '内容查看',
        'sign_ups': '注册',
        checkout: '发起结账',
        'add_to_cart': '加入购物车',
        purchase: '购买',
        roas: 'ROAS',
        'page_view_number': '落地页浏览量',
        'view_content_number': '内容查看',
        'sign_ups_number': '注册',
        'checkout_number': '发起结账',
        'add_to_cart_number': '加入购物车',
        'purchase_number': '购买',
        'roas_number': 'ROAS',
        'page_view_value': '落地页浏览量价值',
        'view_content_value': '内容查看价值',
        'sign_ups_value': '注册价值',
        'checkout_value': '发起结账价值',
        'add_to_cart_value': '加入购物车价值',
        'purchase_value': '购买价值',
        'roas_value': 'ROAS价值',
        'page_view_cost': '落地页浏览量费用',
        'view_content_cost': '内容查看费用',
        'sign_ups_cost': '注册费用',
        'checkout_cost': '发起结账费用',
        'add_to_cart_cost': '加入购物车费用',
        'purchase_cost': '购买费用',
        'roas_cost': 'ROAS费用',
        'video_plays_at25': '25%视频观看率',
        'video_plays_at50': '50%视频观看率',
        'video_plays_at75': '75%视频观看率',
        'video_plays_at100': '100%视频观看率',
        'cost_per_video_play': '单次视频观看成本',
        'adgroup_id': '广告组ID',
        'bid_goal': '竞价目标',
        'bid': '竞价数值',
        'lifetime_budget': '总预算',
        'daily_budget': '单日预算',
        'adgroup_name': '广告组名称',
        'ad_id': '广告ID',
        'ad_name': '广告名称',
        'entity_creative_id': '素材ID',
        'id': '素材ID',
        'creative_name': '素材名称',
        'creative_type': '素材类型',
        'media_type': '媒体文件类型',
        'tags': 'Tags',
        'ue_owner': 'UE Owner',
        'ue_owner_sub_tag': 'UE Owner Sub Tag',
        'created_date': '创建日期',
        'start_date': '开启日期',
        'end_date': '停投日期',
        'reject_reason': '拒绝原因',
        'ad_type': '广告类型',
        'target_market': '目标国家',
        'product_link': '产品链接',
        'product_url': '产品链接',
        'brand_name': '品牌名称',
        'headline': '标题',
        'propose': '分析与建议',
        'campaign_status': '广告系列状态',
        'adgroup_status': '广告组状态',
        'ad_status': '广告状态',
        'ad_style': '广告样式',
        'position': '广告版位',
        'skadnetwork_properties': 'SKAdNetwork',
        'device': '设备',
        'bid_type': '竞价类型',
        'creative_status': '状态',
        'full_report': 'Full report',
        'campaign': '广告系列',
        'adGroup': '广告组',
        'ad': '广告',
        'creative': '素材',
        'total_ad_count': '所有广告条数',
        'running_count': '在跑广告条数',
        'media_reject_count': '被拒广告条数',
        'reject_rate': '被拒率',
        'cmp_reject_count': '严重违规次数',
        reason: '违规原因',
        'ad_ids': '广告',
        user: '操作人',
        'snapchat_organization': 'BA',
        'sort_index': 'Index',
        'daily_spend_avg': '日平均花费',
        'spend_percent': '花费占比',
        'product_audience': '人群类型',
        country: '国家',
        total: '总计',
        'ad_types': '附件类型',
        'web_url': '落地链接',
        deepLinkObj: '落地链接',
        'story_start_time': '开始时间',
        'story_end_time': '结束时间',
        'story_last_updated_time': '上次更新时间',
        'story_opens': 'Story 打开次数',
        'cost_per_story_opens': '单次Story打开成本',
        'story_opens_rate': 'Story 打开率',
        'story_completes': 'Story 完整观看次数',
        'completed_story_view_percentage': 'Story 完整观看率',
        'campaign_start_time': '广告系列开始时间',
        'campaign_end_time': '广告系列结束时间',
        'campaign_source_updated_at': '广告系列上次更新时间',
        'adgroup_start_time': '广告组开始时间',
        'adgroup_end_time': '广告组结束时间',
        'adgroup_source_updated_at': '广告组上次更新时间',
        'ad_source_updated_at': '广告上次更新时间',
        'delivery_type': '投放类型',
        'some_type1': '素材类型',
        'some_type2': '投放类型',
        'total_installs_sk_ad_network': '应用安装（SKAN）',
        'cost_per_sk_ad_network': '应用安装单次成本（SKAN）',
        'skad_network_unknown_events': '未知事件（SKAN）',
        'skad_network_assisted_installs': '助攻安装数（SKAN）',
        'skad_network_withhelds': '流失数量（SKAN）',
        conversion: '转化数',
        cost_per_conversion: '转化成本',
        conversion_rate: '转化率',
        skan_conversion: '转化量 (SKAN)',
        skan_cost_per_conversion: '转化成本 (SKAN)',
        skan_conversion_rate: '转化率 (SKAN)',
        conversion_purchases_sk_ad_network_total: '购买（SKAN）',
        conversion_add_cart_sk_ad_network_total: '加入购物车（SKAN）',
        cost_per_SK_Ad_Network_ADDs_to_Cart: '加入购入车成本（SKAN）',
        conversion_app_opens_sk_ad_network_total: '应用打开（SKAN）',
        cost_per_SK_Ad_Network_App_Opens: '应用打开单次成本（SKAN）',
        conversion_sign_ups_sk_ad_network_total: '注册（SKAN）',
        cost_per_SK_Ad_Network_Sign_Ups: '注册单次成本（SKAN）',
        conversion_purchases_sk_ad_network_value_total: '购买价值（SKAN）',
        ROAS: 'ROAS（SKAN）',
        CVR: ' CVR（SKAN）',
        withhelds_Rate: 'Withhelds Rate',
        assisted_Rate: 'Assisted Rate',
        cost_per_SK_Ad_Network_Purchases: '单次购买成本（SKAN）'
    },
    authorMgr: {
        loginType: '请选择登录方式',
        baidu: '百度账户登录',
        google: 'Google账户登录',
        useName: '用户名',
        company: '公司',
        name: '姓名',
        position: '职位',
        userType: '用户类型',
        roles: '角色',
        media: '媒体',
        agents: '代理',
        accounts: '账户',
        status: '状态',
        phone: '手机号码',
        email: '邮箱',
        detail: '查看详情',
        permission: '权限说明',
        userInfo: '用户信息',
        roleAdd: '新增角色',
        menuAdd: '新增功能',
        roleEdit: '编辑角色',
        menuEdit: '编辑功能',
        roleName: '角色名称',
        roleDesc: '角色描述',
        menusName: '对应菜单',
        menusLevel: '权限范围',
        functionName: '功能名称',
        menuId: '菜单ID',
        uri: '菜单URI',
        api: '关联URI',
        read: '只读',
        readWrite: '读写',
        parentId: '上级id',
        parentName: '上级名称',
        type: '类型',
        uriName: 'uri描述',
        createdTime: '创建时间',
        updatedTime: '更新时间',
        updatedUserId: '操作人Id',
        uriStatus: '状态',
        show: '菜单栏展示',
        order: '菜单栏序号',
        uriAdd: '新增URI',
        uriEdit: '编辑URI',
        desc: '功能描述',
        menuName: '菜单名称',
        menuLevel: '菜单权限',
        apiId: 'URI ID',
        apiUri: '关联URI',
        apiName: 'URI描述',
        apiLevel: 'URI权限',
        sort: '菜单栏序号'
    },
    formLabel: {
        menuName: '菜单',
        columnName: '列',
        permission: '权限',
        menuPermission: '菜单权限',
        uriText: 'uri',
        uriType: '类型',
        isShowMenu: '菜单栏展示',
        sort: '菜单栏序号',
        certName: 'API证书名称',
        device: '设备',
        adType: '广告主类型',
        remark: '备注'
    },
    formPh: {
        url: '请输入对应url',
        api: '请选择关联uri',
        select: '请选择',
        menuName: '请选择菜单',
        permission: '请选择权限',
        uriName: '请输入uri的描述',
        parentId: '请输入上级id',
        uriText: '请输入uri',
        uriType: '请选择类型',
        roleType: '请选择菜单',
        isShowMenu: '请选择是否在菜单栏展示',
        sort: '请设置菜单栏序号',
        uriStatus: '请选择uri的状态',
        roleName: '请输入角色名称',
        roleDesc: '请输入角色描述',
        functionName: '请输入功能模块名称'
    },
    tableInfo: {
        yesterdayRank: '昨日排名',
        lastRank: '上期排名',
        total: '总计',
        targetCpa: '目标CPA',
        applicationName: '应用名称',
        status: '状态',
        budgetAmount: '总预算',
        dailyBudget: '日预算',
        defaultCpt: '默认CPT Bid',
        searchMatch: 'Search Match',
        cost: '花费',
        showNum: '展示数',
        clickNum: '点击数',
        clickRatio: '点击率',
        install: '安装',
        clickInstallRatio: '点击安装率',
        avCpt: '平均CPT',
        avCpa: '平均CPA',
        locate: '国家/地区',
        adGroup: '广告组名称',
        adPlan: '广告系列名称',
        date: '日期',
        cptBid: 'CPT Bid',
        campaignId: '广告系列ID',
        adGroupId: '广告组ID',
        keywordId: '关键词ID',
        newDownloadsRate: '新下载数占比',
        redownloadsRate: '重新下载数占比',
        latOffInstallsRate: 'Lat-off安装量占比',
        latOnInstallsRate: 'Lat-on安装量占比',
        latOffInstalls: 'Lat-off安装',
        latOnInstalls: 'Lat-on安装',
        newDownloads: '新下载数',
        redownloads: '重新下载数',
        tableAction: '操作',
        keyword: '关键词',
        heat: '热度',
        fashion: '流行度',
        contend: '竞争度',
        ranking: '排名',
        addToCurrent: '添加当前页',
        country: '国家/地区',
        startTime: '开始日期',
        endTime: '结束日期',
        automatedKeywordsOptIn: '搜索匹配',
        negativeWords: '否定词',
        account: '账户',
        agent: '代理',
        matchType: '匹配类型',
        exact: '精准匹配',
        broad: '模糊匹配',
        searchword: '搜索词',
        searchwordSource: '来源',
        productName: '产品名称',
        productType: '产品类型',
        iosLink: '产品链接',
        agentName: '代理',
        countriesOrRegions: '目标市场',
        kpi: 'KPI',
        accountId: '账户ID',
        hasCap: '付款类型',
        createdTime: '创建日期',
        company: '公司名称',
        isAgency: '投放类型',
        email: '联系邮箱',
        preCap: '预付',
        suffCap: '后付',
        daitou: '代投',
        zitou: '自投',
        certName: 'API证书名称',
        accountName: '账户名称',
        expiratTime: '过期时间',
        appCount: '竞价应用数',
        rate: '竞价应用占比',
        creativeType: '素材类型',
        deliveryType: '投放类型'
    },
    verify: {
        action: '操作成功',
        updateSuccess: '更新成功'
    },
    accountInvite: {
        email: '请输入被邀请人邮箱',
        account: '请确认被邀请人管理账户',
        role: '请分配被邀请人的角色身份',
        sender: '发件人',
        receiver: '收件人',
        subject: '邮件主题',
        content: '邮件正文',
        distribution: '分配权限',
        invite: '邀请',
        sended: '发送成功',
        copySuccess: '复制成功',
        copyFail: '复制失败，请重试'
    },
    home: {
        home: '首页',
        'solutions': '解决方案',
        'medias': '合作伙伴',
        'multi_channel': '海量渠道',
        'marketing_learn': '营销课堂',
        'cases': '成功案例',
        'about': '关于我们',
        'course': '营销课堂',
        'FAQ': '帮助中心',
        'company_name': '公司名称',
        'user_name': '姓名',
        phone: '电话号码',
        code: '验证码',
        email: '邮箱地址',
        'product_name': '推广产品名称'
    },
    bulkTool: {
        'validateTip': '字段空缺',
        'validateTip1': '未匹配的内容',
        'validateTip2': 'Excel文件格式校验成功，请点击上传！',
        'validateTip3': 'Excel文件格式错误，请检查并修复后重新选择文件！',
        'validateTip4': '只能为数字;',
        'validateTip5': '只能为com.xxx.xxx的格式',
        'validateTip6': '无效的DeepLink URL',
        'validateTip7': '无效的媒体文件格式',
        'validateTip8': '错误的URL格式;',
        'validateTip9': '超过{{cnt}}字符限制',
        'validateTip10': '必须为PNG格式;',
        'validateTip11': '只能包含英文字符',
        'validateTip12': '最少需要3个视频文件',
        'validateTip13': '最多只能有20个视频文件',
        'validateTip15': '只能包含英文字符',
        'validateTip16': 'DeepLink数量和视频数量不相同',
        'validateTip17': '只能是 Enabled/Disabled;',
        'validateTip18': '不支持的CTA',
        'validateTip19': '只能为：Auto Advance, Loop Each Snap',
        'validateTip20': '只能为：App Install, Web Site',
        'validateTip21': '未识别的字段',
        'validateTip22': '上传成功！',
        'validateTip23': '上传失败，请检查后重试！',
        'validateTip24': '您只能上传PNG格式的图片！',
        'validateTip25': '请先选择图标文件',
        'validateTip27': '上传失败，请稍后重试！',
        'validateTip28': '请上传zip格式的文件！',
        'validateTip29': '文件大小超过1GB！',
        'validateTip30': '请先选择media文件！',
        'validateTip31': '未在您上传的压缩包中找到该视频文件',
        'validateTip32': '所有视频文件都不匹配，请检查！',
        'validateTip33': '没有找到任何有效的视频文件，请重新上传Excel表格或视频压缩包！',
        'validateTip34': '请先选择广告账户',
        'validateTip35': '只能为：',
        'validateTip36': '您只能上传PNG格式的图片哦！'
    }
};



// WEBPACK FOOTER //
// ./src/i18n/langs/cmp/cn.js